import type { FC, MouseEventHandler, PropsWithChildren } from 'react';
import { Button } from '../button/Button';
import styles from './modal.module.css';

export const ModalHeader: FC<
  PropsWithChildren & {
    title: string;
    onClose: MouseEventHandler;
  }
> = (props) => {
  const { title = ' ', onClose } = props;
  return (
    <div id={'modal-header'} className={styles.header}>
      <div className={styles.header_title}>{title}</div>
      <Button id={'modal_xmark-close'} icon="Xmark" onClick={onClose} />
    </div>
  );
};
